export const JOB_ALERT_CARD_INTERVAL = 5;

export type InterleavedJobListItem<T> =
  | {
      type: "job";
      key: string;
      job: T;
      index: number;
    }
  | {
      type: "subscription-card";
      key: string;
      afterJobCount: number;
    };

export function interleaveJobAlertCards<T>(
  jobs: T[],
  _interval?: number,
): InterleavedJobListItem<T>[] {
  const result: InterleavedJobListItem<T>[] = [];

  for (let i = 0; i < jobs.length; i++) {
    result.push({
      type: "job",
      key: `job-${i}`,
      job: jobs[i],
      index: i,
    });

    const jobCount = i + 1;
    if (jobCount === 5) {
      result.push({
        type: "subscription-card",
        key: `job-alert-card-5`,
        afterJobCount: 5,
      });
    } else if (jobCount === 15) {
      result.push({
        type: "subscription-card",
        key: `job-alert-card-15`,
        afterJobCount: 15,
      });
    }
  }

  return result;
}
